// Shuffle vendor related products and keep only 4
(function () {
  var list = document.querySelector('ul.dr_related_id');
  if (!list) return;

  // Shuffle children randomly
  var items = Array.from(list.children);
  for (var i = items.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    list.appendChild(items[j]);
    items.splice(j, 1, items[i]);
  }

  // Remove everything after the 4th item
  var children = list.querySelectorAll('.grid__item');
  for (var k = 4; k < children.length; k++) {
    children[k].remove();
  }
})();
